import { Component, AfterViewInit } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { DashboardAccessPermissions } from '../dashboard-access.model';

@Component({
    selector: 'cv-permission-cell-renderer',
    templateUrl: './permission-cell-renderer.component.html',
    styleUrls: ['./permission-cell-renderer.component.scss'],
})
export class PermissionCellRendererComponent implements AfterViewInit {
    public params;

    public owner = DashboardAccessPermissions.WriteTheirs;
    public ownerLabel: string;
    public view = DashboardAccessPermissions.ReadTheirs;

    constructor(
        private cvLocalizationService: CVLocalizationService,
    ) { }

    ngAfterViewInit(): void {
    }

    async agInit(params) {
        await this.cvLocalizationService.GetSection('Dashboard_Access');
        this.params = params;
        this.ownerLabel = await this.cvLocalizationService.GetLocalText('Dashboard_Access', 'Owner', 'Owner');
    }

    onValueChange(option) {
        const itemToUpdate = [];
        itemToUpdate.push(this.params.data);
        this.params.api.applyTransaction({
            update: itemToUpdate
        });
        this.params.context.update(this.params.data);
    }
}
